import { createAction, props } from '@ngrx/store';
// ========= Feedback Management ==========
export const setFeedbackListPageNumber = createAction('[Feedback Management] Set Feedback List Page Number', props<{ pageNumberFeedbackList: number }>());
export const setFeedbackListItemsPerPage = createAction('[Feedback Management] Set Feedback List Items Per Page', props<{ itemsPerPageFeedbackList: number }>());
